/* Papierschmiede — Live-Suche (21.10.2026)
   Markup: snippets/ps-suche.liquid, Treffer: sections/ps-suche-ergebnisse.liquid.

   - Jeder Link mit data-ps-suche-auf oeffnet den Dialog statt /search.
   - Ab zwei Zeichen holt das Skript Treffer (Predictive Search), entprellt,
     aeltere Anfragen werden abgebrochen, Antworten je Begriff gemerkt.
   - 0 Treffer und Umlaut-Schreibweise im Begriff („tuerkei“): einmal mit
     Umlauten nachfragen. Hilft das, gilt ab dann diese Schreibweise, auch
     fuer Enter.
   - Enter ohne markierten Treffer fuehrt auf /search, damit Shopify die
     Anfrage im Bericht „Suchanfragen“ zaehlt. */
(function () {
  if (customElements.get('ps-suche')) return;

  var ABSCHNITT = 'ps-suche-ergebnisse';
  var MIN_ZEICHEN = 2;

  function mitUmlauten(text) {
    return text
      .replace(/ae/g, 'ä').replace(/oe/g, 'ö').replace(/ue/g, 'ü')
      .replace(/Ae/g, 'Ä').replace(/Oe/g, 'Ö').replace(/Ue/g, 'Ü');
  }

  class PsSuche extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.feld = this.querySelector('input[name="q"]');
      this.leeren = this.querySelector('[data-ps-suche-leeren]');
      this.ziel = this.querySelector('[data-ps-suche-treffer-ziel]');
      this.start = this.querySelector('[data-ps-suche-start]');
      this.hinweis = this.querySelector('[data-ps-suche-hinweis]');
      this.hinweisBegriff = this.querySelector('[data-ps-suche-hinweis-begriff]');
      this.merker = new Map();
      this.umgeschrieben = null;
      this.timer = null;
      this.abbruch = null;

      document.addEventListener('click', (e) => {
        var auf = e.target.closest('[data-ps-suche-auf]');
        if (!auf || e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        this.oeffnen();
      });

      this.querySelector('[data-ps-suche-zu]').addEventListener('click', () => this.schliessen());
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('ps-suche-offen');
      });
      // Tipp auf die Abdunklung (ausserhalb des Panels) schliesst.
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.schliessen();
      });

      this.feld.addEventListener('input', () => this.eingabe());
      this.feld.addEventListener('keydown', (e) => this.tasten(e));
      this.ziel.addEventListener('keydown', (e) => this.tasten(e));
      this.start.addEventListener('keydown', (e) => this.tasten(e));
      this.leeren.addEventListener('click', () => {
        this.feld.value = '';
        this.eingabe();
        this.feld.focus();
      });
      this.form.addEventListener('submit', (e) => {
        var q = this.feld.value.trim();
        if (!q) { e.preventDefault(); return; }
        if (this.umgeschrieben && this.umgeschrieben.von === q) this.feld.value = this.umgeschrieben.zu;
      });
    }

    oeffnen() {
      if (this.dialog.open) return;
      // Ein offenes Handy-Menue zuerst schliessen, sonst liegt es darueber.
      var schublade = document.querySelector('.ps-header .ps-drawer[open]');
      if (schublade) schublade.open = false;
      this.dialog.showModal();
      document.documentElement.classList.add('ps-suche-offen');
      this.feld.focus();
      if (this.feld.value) this.feld.select();
    }

    schliessen() {
      if (this.dialog.open) this.dialog.close();
    }

    eingabe() {
      var q = this.feld.value.trim();
      this.leeren.hidden = q.length === 0;
      clearTimeout(this.timer);
      if (q.length < MIN_ZEICHEN) {
        if (this.abbruch) this.abbruch.abort();
        this.zeigeStart(null);
        return;
      }
      this.timer = setTimeout(() => this.suchen(q), 180);
    }

    async suchen(q) {
      if (this.abbruch) this.abbruch.abort();
      this.abbruch = new AbortController();
      this.setAttribute('aria-busy', 'true');
      try {
        var antwort = await this.holen(q, this.abbruch.signal);
        var alternative = mitUmlauten(q);
        this.umgeschrieben = null;
        if (antwort.treffer === 0 && alternative !== q) {
          var zweite = await this.holen(alternative, this.abbruch.signal);
          if (zweite.treffer > 0) {
            antwort = zweite;
            this.umgeschrieben = { von: q, zu: alternative };
          }
        }
        if (this.feld.value.trim() !== q) return;
        if (antwort.treffer === 0) {
          this.zeigeStart(q);
        } else {
          this.ziel.innerHTML = antwort.html;
          this.ziel.hidden = false;
          this.start.hidden = true;
          this.feld.setAttribute('aria-expanded', 'true');
        }
      } catch (fehler) {
        if (fehler.name !== 'AbortError') this.zeigeStart(null);
      } finally {
        this.removeAttribute('aria-busy');
      }
    }

    async holen(q, signal) {
      var schluessel = q.toLowerCase();
      if (this.merker.has(schluessel)) return this.merker.get(schluessel);
      var parameter = new URLSearchParams({
        q: q,
        'resources[type]': 'product,collection,page,query',
        'resources[limit]': '6',
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last',
        section_id: ABSCHNITT
      });
      var r = await fetch(this.dataset.url + '?' + parameter.toString(), { signal: signal });
      if (!r.ok) throw new Error('Suche ' + r.status);
      var doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      var block = doc.querySelector('[data-ps-suche-treffer]');
      var ergebnis = {
        treffer: block ? parseInt(block.dataset.psSucheTreffer, 10) || 0 : 0,
        html: block ? block.outerHTML : ''
      };
      this.merker.set(schluessel, ergebnis);
      return ergebnis;
    }

    zeigeStart(begriffOhneTreffer) {
      this.ziel.innerHTML = '';
      this.ziel.hidden = true;
      this.start.hidden = false;
      this.hinweis.hidden = !begriffOhneTreffer;
      if (begriffOhneTreffer) this.hinweisBegriff.textContent = begriffOhneTreffer;
      this.feld.setAttribute('aria-expanded', begriffOhneTreffer ? 'true' : 'false');
    }

    /* Pfeiltasten wandern durch die sichtbaren Treffer, Pfeil hoch am
       ersten zurueck ins Feld. Enter auf einem Treffer ist ein normaler
       Linkklick. */
    tasten(e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var bereich = this.ziel.hidden ? this.start : this.ziel;
      var ziele = Array.prototype.slice.call(bereich.querySelectorAll('[data-ps-suche-ziel]'));
      if (!ziele.length) return;
      var i = ziele.indexOf(document.activeElement);
      e.preventDefault();
      if (e.key === 'ArrowDown') {
        (ziele[i + 1] || ziele[ziele.length - 1]).focus();
      } else if (i <= 0) {
        this.feld.focus();
      } else {
        ziele[i - 1].focus();
      }
    }
  }

  customElements.define('ps-suche', PsSuche);
})();
